export default __webpack_public_path__ + "static/media/Barbieri-MarcaGrafica-01.3c31cc8d.png";